export {
  IntentionsWidgetForm as default,
  getStaticProps,
  getStaticPaths,
} from 'modules/intention/widget/IntentionsWidgetForm'
